<template>
    <div class="tc" :class="[`tc--${variant}`, { 'tc--clickable': clickable }]">
        <div v-if="icon" class="tc-icon">
            <v-icon size="16">{{ icon }}</v-icon>
        </div>
        <div class="tc-text">
            <slot>{{ text }}</slot>
        </div>
        <button v-if="!hideClose" type="button" class="tc-close" @click.stop="$emit('close')">
            <v-icon size="13">mdi-close</v-icon>
        </button>
    </div>
</template>

<script>
export default {
    name: "ToastCard",
    props: {
        text: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
        variant: {
            type: String,
            default: 'info',
        },
        hideClose: {
            type: Boolean,
            default: false,
        },
        clickable: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped>
.tc {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-left: 3px solid var(--v-outline2-base);
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, .25);
}

.tc--clickable {
    cursor: pointer;
}

.tc--success {
    border-left-color: var(--v-success-base);
}

.tc--error {
    border-left-color: var(--v-error-base);
}

.tc--info {
    border-left-color: var(--v-secondary-base);
}

.tc-icon {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.tc--success .tc-icon {
    background: rgba(0, 153, 102, .15);
}

.tc--success .tc-icon .v-icon {
    color: var(--v-success-base) !important;
}

.tc--error .tc-icon {
    background: rgba(232, 92, 92, .15);
}

.tc--error .tc-icon .v-icon {
    color: var(--v-error-base) !important;
}

.tc--info .tc-icon {
    background: rgba(102, 204, 204, .15);
}

.tc--info .tc-icon .v-icon {
    color: var(--v-secondary-base) !important;
}

.tc-text {
    flex: 1;
    min-width: 0;
    font-size: var(--fs-input);
    font-weight: 500;
    line-height: 18px;
    color: var(--v-txtPrimary-base);
}

.tc-close {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    color: var(--v-txtMuted-base);
    transition: background .15s, color .15s;
}

.tc-close:hover {
    background: var(--v-surface2-base);
    color: var(--v-txtPrimary-base);
}

.tc-close .v-icon {
    color: inherit !important;
}
</style>
